import { create } from 'zustand'

import type { AuthState } from './auth.store.types'

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  permissions: new Set(),
  status: 'unknown',
  setSession: (s) =>
    set({
      accessToken: s.accessToken,
      user: s.user,
      permissions: new Set(s.permissions),
      status: 'authenticated',
    }),
  setUser: (user) => set({ user }),
  clear: () =>
    set({
      accessToken: null,
      user: null,
      permissions: new Set(),
      status: 'anonymous',
    }),
}))

/** UI-level permission check (servers always re-check). */
export function useCan(permission: string): boolean {
  return useAuthStore((s) => s.permissions.has(permission))
}
